/* Featured drop: plan toggle + commitment tiers + live pricing + video upload slot */
(function () {
  document.querySelectorAll('.featured-drop-section .bb-feature').forEach(function (root) {
    var dataEl = root.querySelector('.bb-pricing-data');
    if (!dataEl) return;

    var data = JSON.parse(dataEl.textContent);
    var tiers = data.tiers || [];
    var oneTime = data.oneTime;

    var toggle = root.querySelector('.bb-toggle');
    var tiersWrap = root.querySelector('.bb-tiers');
    var tierButtons = root.querySelectorAll('.bb-tier');
    var priceNow = root.querySelector('.bb-price-now');
    var priceWas = root.querySelector('.bb-price-was');
    var saveBadge = root.querySelector('.bb-save');
    var perBox = root.querySelector('.bb-perbox');
    var planNote = root.querySelector('.bb-plan-note');
    var buyBtn = root.querySelector('.bb-buy-btn');
    var revCount = root.querySelector('.bb-rev-count');

    var mode = 'sub';
    var tier = (tiersWrap && tiersWrap.dataset.defaultTier) || (tiers[0] && tiers[0].id);

    function findTier(id) {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].id === id) return tiers[i];
      }
      return null;
    }

    function render() {
      var sub = mode === 'sub';
      if (toggle) {
        toggle.classList.toggle('sub', sub);
        toggle.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('active', b.dataset.mode === mode);
        });
      }
      if (tiersWrap) tiersWrap.hidden = !sub;
      tierButtons.forEach(function (t) {
        t.classList.toggle('active', t.dataset.tier === tier);
      });

      var now, was, save, note, reviews, ctaLabel, ctaLink;
      if (sub) {
        var t = findTier(tier);
        if (!t) return;
        now = data.currencySymbol + t.perBox;
        was = data.currencySymbol + oneTime.price;
        save = 'Save £' + t.save + '/box';
        note = t.note;
        reviews = data.subReviews;
        ctaLabel = data.ctaSubscribe;
        ctaLink = data.ctaSubscribeLink;
      } else {
        now = data.currencySymbol + oneTime.price;
        was = null;
        save = null;
        note = oneTime.note;
        reviews = data.oneTimeReviews;
        ctaLabel = data.ctaOneTime;
        ctaLink = data.ctaOneTimeLink;
      }

      if (priceNow) priceNow.textContent = now;
      if (priceWas) {
        priceWas.style.display = was ? '' : 'none';
        if (was) priceWas.textContent = was;
      }
      if (saveBadge) {
        saveBadge.style.display = save ? '' : 'none';
        if (save) saveBadge.textContent = save;
      }
      if (perBox) perBox.style.display = sub ? '' : 'none';
      if (planNote) planNote.textContent = note;
      if (buyBtn) {
        buyBtn.textContent = ctaLabel;
      }
      if (revCount) revCount.textContent = reviews;
    }

    if (toggle) {
      toggle.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          mode = b.dataset.mode;
          render();
        });
      });
    }

    tierButtons.forEach(function (t) {
      t.addEventListener('click', function () {
        tier = t.dataset.tier;
        mode = 'sub';
        render();
      });
    });

    function addToCart(variantId, sellingPlanId, fallbackHref) {
      if (buyBtn) {
        buyBtn.setAttribute('disabled', '');
        buyBtn.dataset.origText = buyBtn.textContent;
        buyBtn.textContent = 'Adding…';
      }
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sellingPlanId) body.items[0].selling_plan = Number(sellingPlanId);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          if (buyBtn) { buyBtn.removeAttribute('disabled'); buyBtn.textContent = buyBtn.dataset.origText; }
          window.location.href = fallbackHref || '/cart';
        }
      }).catch(function () {
        if (buyBtn) { buyBtn.removeAttribute('disabled'); buyBtn.textContent = buyBtn.dataset.origText; }
        window.location.href = fallbackHref || '/cart';
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        try {
          buyBtn.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(.97)' }, { transform: 'scale(1)' }],
            { duration: 200 }
          );
        } catch (_) {}
        var sub = mode === 'sub';
        if (sub) {
          var activeTier = findTier(tier);
          var subVariantId = data.subVariantId;
          var sellingPlanId = activeTier && activeTier.sellingPlanId ? activeTier.sellingPlanId : null;
          if (subVariantId) { addToCart(subVariantId, sellingPlanId, data.ctaSubscribeLink); return; }
          window.location.href = data.ctaSubscribeLink || '#';
        } else {
          var oneTimeVariantId = data.oneTime.variantId;
          if (oneTimeVariantId) { addToCart(oneTimeVariantId, null, data.ctaOneTimeLink); return; }
          window.location.href = data.ctaOneTimeLink || '#';
        }
      });
    }

    render();

    /* ===== video upload slot (persists in IndexedDB) ===== */
    /* Skipped entirely when a video has been set in the theme editor (.bb-video-input absent). */
    var slot = root.querySelector('.bb-video-slot');
    if (!slot) return;

    var input = slot.querySelector('.bb-video-input');
    if (!input) return;
    var empty = slot.querySelector('.bb-video-empty');
    var posterSrc = slot.dataset.poster;
    var dbKey = 'thisMonthsDrop-' + (slot.dataset.sectionId || 'default');
    var DB_NAME = 'bbVideoStore';
    var STORE_NAME = 'videos';
    var objUrl = null;

    function dbOpen() {
      return new Promise(function (resolve, reject) {
        var openReq = indexedDB.open(DB_NAME, 1);
        openReq.onupgradeneeded = function () { openReq.result.createObjectStore(STORE_NAME); };
        openReq.onsuccess = function () { resolve(openReq.result); };
        openReq.onerror = function () { reject(openReq.error); };
      });
    }

    function dbGet() {
      return dbOpen().then(function (db) {
        return new Promise(function (resolve) {
          var req = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(dbKey);
          req.onsuccess = function () { resolve(req.result || null); };
          req.onerror = function () { resolve(null); };
        });
      }).catch(function () { return null; });
    }

    function dbSet(blob) {
      return dbOpen().then(function (db) {
        db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME).put(blob, dbKey);
      }).catch(function () {});
    }

    function showVideo(blob) {
      if (objUrl) URL.revokeObjectURL(objUrl);
      objUrl = URL.createObjectURL(blob);
      slot.querySelectorAll('.bb-video-empty, video, .bb-video-replace').forEach(function (n) { n.remove(); });

      var video = document.createElement('video');
      video.src = objUrl;
      video.poster = posterSrc;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.controls = true;
      slot.insertBefore(video, input);

      var replaceBtn = document.createElement('button');
      replaceBtn.type = 'button';
      replaceBtn.className = 'bb-video-replace';
      replaceBtn.textContent = 'Replace video';
      replaceBtn.addEventListener('click', function () { input.click(); });
      slot.insertBefore(replaceBtn, input);
    }

    function accept(file) {
      if (!file || !file.type.startsWith('video/')) return;
      dbSet(file);
      showVideo(file);
    }

    if (empty) empty.addEventListener('click', function () { input.click(); });
    input.addEventListener('change', function (e) { accept(e.target.files[0]); });
    slot.addEventListener('dragover', function (e) { e.preventDefault(); slot.classList.add('is-drag'); });
    slot.addEventListener('dragleave', function () { slot.classList.remove('is-drag'); });
    slot.addEventListener('drop', function (e) {
      e.preventDefault();
      slot.classList.remove('is-drag');
      accept(e.dataTransfer.files[0]);
    });

    dbGet().then(function (blob) { if (blob) showVideo(blob); });
  });
})();